import Button from '@mui/material/Button'
import { useState } from 'react'

import { getBrand } from 'pared/utils/brand'

const SendEmailButton = ({ html }: { html: string }) => {
  const [isSendingEmail, setIsSendingEmail] = useState(false)
  const [hasSentEmail, setHasSentEmail] = useState(false)
  const brand = getBrand()
  const sendEmail = async () => {
    const shouldSendEmail = window.confirm(`Send chart to these emails?`)
    if (shouldSendEmail) {
      setIsSendingEmail(true)
      await fetch(
        `${process.env.REACT_APP_BE_BASE_URL}/send_acr_report_email`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            html,
            brand,
          }),
        },
      )
      setIsSendingEmail(false)
      setHasSentEmail(true)
    }

    return false
  }

  const handleClick = async () => {
    await sendEmail()
  }

  return (
    <Button
      disabled={isSendingEmail || hasSentEmail}
      onClick={handleClick}
      data-cy="send-email"
    >
      Send Email
    </Button>
  )
}

export default SendEmailButton
